import React, { useContext } from 'react';
import ModalModule from '../modal';
import AutoFundAccount from './AutoFundAccount.component';

const { Modal, ModalContext } = ModalModule;

const AutoFundAccountModal = ({ modalId, data: { completionCallback } }) => {
	const { closeModal } = useContext(ModalContext);

	const closeAutoFundAccountModal = () => {
		closeModal(modalId);
	};

	return (
		<Modal
			modalId={modalId}
			className="common-payment auto-fund-account-modal"
			header="Auto-Fund Account"
			size="small"
			hideFooter
		>
			<AutoFundAccount
				closeAutoFundAccountModal={closeAutoFundAccountModal}
				completionCallback={completionCallback}
			/>
		</Modal>
	);
};

export default AutoFundAccountModal;
